// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 378 ? "add-micro" : chunkId) + "-" + __webpack_require__.h().slice(0, 8) + "-v1745272306317.css";
};